export function getColumnFromId(id: string, idsList: Array<string>): string {
  const index = idsList.findIndex(item => item === id);
  return `${index}`;
}
